import React from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import {
  FaBalanceScale, FaHandshake, FaBriefcase,
  FaFileContract, FaHouseUser, FaShieldAlt
} from "react-icons/fa";
import { Link } from "react-router-dom";
import "../App.css";

const services = [
  {
    title: "Personal Injury & Public Liability",
    slug: "personal-injury",
    desc: "Claims for accidents and injuries.",
    icon: <FaShieldAlt />
  },
  {
    title: "Employment & Labour Law",
    slug: "employment-law",
    desc: "Workplace rights, contracts, and disputes.",
    icon: <FaBriefcase />
  },
  {
    title: "Marriage & Matrimonial Property",
    slug: "marriage-property",
    desc: "Prenuptial agreements, divorce, and property division.",
    icon: <FaBalanceScale />
  },
  {
    title: "Estates, Trusts & Wills",
    slug: "estates-wills",
    desc: "Drafting wills, estate planning, and trust management.",
    icon: <FaFileContract />
  },
  {
    title: "Consumer Protection",
    slug: "consumer-protection",
    desc: "Assisting clients with consumer rights issues.",
    icon: <FaHandshake />
  },
  {
    title: "Family Law & Divorce Lawyers",
    slug: "family-law",
    desc: "Custody, maintenance, and divorce proceedings.",
    icon: <FaHouseUser />
  },
];

const Services = () => {

  // Split into two groups
  const leftServices = services.slice(0, 3);
  const rightServices = services.slice(3, 6);

  return (
    <section id="services" className="py-5 bg-white">
      <Container>

        {/* Heading */}
        <h2
          className="text-center fw-bold mb-5"
          style={{
            fontFamily: "'Calisto MT', 'Bookman Old Style', Georgia, serif",
            color: "#8b5e3c",
          }}
        >
          LEGAL SERVICES
        </h2>

        <Row className="align-items-center">

          {/* LEFT COLUMN */}
          <Col md={4} className="d-flex flex-column gap-4">
            {leftServices.map((s, i) => (
              <Link
                key={i}
                to={`/services/${s.slug}`}
                style={{ textDecoration: "none" }}
              >
                <Card className="border-0 shadow-sm text-center service-card h-100">
                  <Card.Body>

                    <div className="service-icon">
                      {s.icon}
                    </div>

                    <Card.Title className="service-title">
                      {s.title}
                    </Card.Title>

                    <Card.Text className="text-muted small mb-0">
                      {s.desc}
                    </Card.Text>

                  </Card.Body>
                </Card>
              </Link>
            ))}
          </Col>

          {/* CENTER IMAGE */}
          <Col md={4} className="text-center my-4 my-md-0">
            <Image
              src="/Medal.png"
              alt="Medal"
              fluid
              style={{ maxWidth: "320px" }}
            />
          </Col>

          {/* RIGHT COLUMN */}
          <Col md={4} className="d-flex flex-column gap-4">
            {rightServices.map((s, i) => (
              <Link
                key={i}
                to={`/services/${s.slug}`}
                style={{ textDecoration: "none" }}
              >
                <Card className="border-0 shadow-sm text-center service-card h-100">
                  <Card.Body>

                    <div className="service-icon">
                      {s.icon}
                    </div>

                    <Card.Title className="service-title">
                      {s.title}
                    </Card.Title>

                    <Card.Text className="text-muted small mb-0">
                      {s.desc}
                    </Card.Text>

                  </Card.Body>
                </Card>
              </Link>
            ))}
          </Col>

        </Row>

      </Container>
    </section>
  );
};

export default Services;